import { render, staticRenderFns } from "./BatchDeletePois.vue?vue&type=template&id=812c85b4&scoped=true"
import script from "./BatchDeletePois.vue?vue&type=script&lang=ts"
export * from "./BatchDeletePois.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812c85b4",
  null
  
)

export default component.exports